import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { toast } from 'react-hot-toast';
import Select from "react-select";

function UserSettings({selectedUser, setIsOpen16}) {
    const [loading, setLoading] = useState(false);
    const darkThemeStyles = {
        control: (styles) => ({
        ...styles,
        backgroundColor: "#151719",
        border: "none",
        color: "#fff",
        }),
        menu: (styles) => ({
        ...styles,
        backgroundColor: "#151719",
        }),
        option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
        color: "#fff",
        }),
        singleValue: (styles) => ({
        ...styles,
        color: "#fff",
        }),
    };
    const [fullname, setFullname] = useState(selectedUser.fullname);
    const [country, setCountry] = useState(selectedUser.country);
    const [gender, setGender] = useState(selectedUser.gender);
    const [profit, setProfit] = useState(selectedUser.profit);
    const [progress, setProgress] = useState(selectedUser.trade_progress);
    const [signal, setSignal] = useState(selectedUser.signals);
    const [planPurchase, setPlanPurchase] = useState(selectedUser.plan_purchase);
    const [message, setMessage] = useState(selectedUser.message);
    const [withdrawText, setWithdrawText] = useState(selectedUser.withdraw_text);
    const [billing, setBilling] = useState(selectedUser.billing);
    const [billingAmount, setBillingAmount] = useState(selectedUser.billing_amount);
    const [maintenance, setMaintenance] = useState(selectedUser.maintenance);
    const [airdrop, setAirdrop] = useState(selectedUser.airdrop);
    const [autotrade, setAutotrade] = useState(selectedUser.autotrade);
    const [address, setAddress] = useState(selectedUser.address);
    const [totalTrade, setTotalTrade] = useState(selectedUser.total_trade);
    const [totalWon, setTotalWon] = useState(selectedUser.total_won);
    const [totalLoss, setTotalLoss] = useState(selectedUser.total_loss);

    const planplist = [
        { value: 0, label: "Disable" },
        { value: 1, label: "Enable" },
    ]
    const autotradelist = [
        { value: "ACTIVE", label: "Active" },
        { value: "INACTIVE", label: "Inactive" },
    ]
    const genderlist = [
        { value: "Male", label: "Male" },
        { value: "Female", label: "Female" },
        { value: "Others", label: "Others" },
    ]
    const UpdateAccount = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ updateaccount: true, email: selectedUser?.email, fullname:fullname,country:country,gender:gender,profit:profit,progress:progress,signal:signal,planPurchase:planPurchase,billing:billing,billingAmount:billingAmount,maintenance:maintenance,airdrop:airdrop,autotrade:autotrade,address:address,message:message,withdrawText:withdrawText,total_trade:totalTrade,total_won:totalWon,total_loss:totalLoss})
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === "success") {
                toast.success(data.result);
                setIsOpen16(false);
                setTimeout(() => {
                    window.location.href = "manage";
                }, 2000);
            }else{
                toast.error(data.message);
            }
            setLoading(false);
        })
        .catch(err => {
            console.error(err);
            setLoading(false);
        })
    }

    return (
      <>
        <p className="mb-2 mt-0 text-light fw-semibold" style={{fontSize: '14px'}}>Update user's profile and settings</p>
        <div className="row">
            <div className="col-md-6">
                <label className="fw-semibold mb-0" style={{fontSize: '14px'}}>User:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder={selectedUser.email}
                        className="inputNone w-100 py-1"
                        value={selectedUser.email}
                        readOnly
                    />
                </div>
            </div>
            <div className="col-md-6">
                <label className="fw-semibold mb-0 mt-2" style={{fontSize: '14px'}}>Fullname:</label>
                <div className={`form-control py-1 pe-1`}>
                    <input 
                        type="text" 
                        placeholder="" 
                        className="inputNone"
                        value={fullname}
                        onChange={(e) => setFullname(e.target.value)}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>Country:</label>
                <div className={`form-control py-1 pe-1`}>
                    <input 
                        type="text" 
                        placeholder="" 
                        className="inputNone"
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>Gender:</label>
                <Select
                    options={genderlist} 
                    value={genderlist.find((opt) => opt.value === gender)}
                    onChange={(e) => {setGender(e.value)}}
                    styles={darkThemeStyles}
                    className="w-full"
                />
            </div>
            <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>Free Airdrops:</label>
                <div className={`form-control py-1 pe-1`}>
                    <input 
                        type="text" 
                        placeholder="" 
                        className="inputNone"
                        value={airdrop}
                        onChange={(e) => setAirdrop(e.target.value)}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>Total Profit:</label>
                <div className={`form-control py-1 pe-1`}>
                    <input 
                        type="text" 
                        placeholder="" 
                        className="inputNone"
                        value={profit}
                        onChange={(e) => setProfit(e.target.value)}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>Total Trades:</label>
                <div className={`form-control py-1 pe-1`}>
                    <input 
                        type="number" 
                        placeholder="" 
                        className="inputNone"
                        value={totalTrade}
                        onChange={(e) => setTotalTrade(e.target.value)}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>Total Won:</label>
                <div className={`form-control py-1 pe-1`}>
                    <input 
                        type="number" 
                        placeholder="" 
                        className="inputNone"
                        value={totalWon}
                        onChange={(e) => setTotalWon(e.target.value)}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>Total Loss:</label>
                <div className={`form-control py-1 pe-1`}>
                    <input 
                        type="number" 
                        placeholder="" 
                        className="inputNone"
                        value={totalLoss}
                        onChange={(e) => setTotalLoss(e.target.value)}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>Trade Progress:</label>
                <div className={`form-control py-1 pe-1`}>
                    <input 
                        type="text" 
                        placeholder="" 
                        className="inputNone"
                        value={progress}
                        onChange={(e) => setProgress(e.target.value)}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>Signal Strength:</label>
                <div className={`form-control py-1 pe-1`}>
                    <input 
                        type="text" 
                        placeholder="" 
                        className="inputNone"
                        value={signal}
                        onChange={(e) => setSignal(e.target.value)}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>Purchase Plan before withdraw</label>
                <Select
                    options={planplist} 
                    value={planplist.find((opt) => opt.value == planPurchase)}
                    onChange={(e) => {setPlanPurchase(e.value)}}
                    styles={darkThemeStyles}
                    className="w-full"
                />
            </div>
            <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>Autotrade</label>
                <Select
                    options={autotradelist} 
                    value={autotradelist.find((opt) => opt.value === autotrade)}
                    onChange={(e) => {setAutotrade(e.value)}}
                    styles={darkThemeStyles}
                    className="w-full"
                />
            </div>
            <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>Address:</label>
                <textarea 
                    type="text" 
                    placeholder=""
                    rows={2} 
                    className="form-control py-1 pe-1"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                />
            </div>
           <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>Withdraw Text:</label>
                <textarea 
                    type="text" 
                    placeholder=""
                    rows={2} 
                    className="form-control py-1 pe-1"
                    value={withdrawText}
                    onChange={(e) => setWithdrawText(e.target.value)}
                />
           </div>
           <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>withdraw Message:</label>
                <textarea 
                    type="text" 
                    placeholder=""
                    rows={2} 
                    className="form-control py-1 pe-1"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />
           </div>
           <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>Billing Message:</label>
                <textarea 
                    type="text" 
                    placeholder=""
                    rows={2} 
                    className="form-control py-1 pe-1"
                    value={billing}
                    onChange={(e) => setBilling(e.target.value)}
                />
            </div>
            <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>Billing Amount:</label>
                <div className={`form-control py-1 pe-1`}>
                    <input 
                        type="text" 
                        placeholder="" 
                        className="inputNone"
                        value={billingAmount}
                        onChange={(e) => setBillingAmount(e.target.value)}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <label className="fw-semibold mt-2 mb-0" style={{fontSize: '14px'}}>Maintenance Gauge:</label>
                <div className={`form-control py-1 pe-1`}>
                    <input 
                        type="text" 
                        placeholder="" 
                        className="inputNone"
                        value={maintenance}
                        onChange={(e) => setMaintenance(e.target.value)}
                    />
                </div>
            </div>
        </div>
        <div className={`myBtn bg-prime w-100 text-center mt-5`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={UpdateAccount}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Update'}</div>
      </>
    )
  }
  
  export default UserSettings